import { render } from "./StartupsComponent.vue?vue&type=template&id=8b7691b4&ts=true"
import script from "./StartupsComponent.vue?vue&type=script&lang=ts"
export * from "./StartupsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__